import { css, jsx } from '@emotion/core';
import React from 'react';
import { connect } from 'react-redux';

import ContentPage from '@/src/cms/components/CMSPage/Content';
import { requestStaticContent } from '@/src/cms/utils';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { ABOUT_ACCESS } from '@/src/shared/constants';
import { bp } from '@/styles';

function Help(props) {
  return (
    <ContentPage
      {...props}
      bodyStyle={css`
        > div > ul {
          display: block;
          list-style-position: inside;
          @media ${bp.sm} {
            margin-left: 32px;
          }
          > li {
            list-style-type: disc;
          }
        }
      `}
    />
  );
}

export async function getStaticProps() {
  const sitepageid = 389;
  const pagedata = await requestStaticContent(sitepageid);
  return { props: { sitepageid, pagedata } };
}

export default connect(mapStateToProps)(withMembershipAccessWrap(Help, ABOUT_ACCESS.MEMBERSHIP));
